import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { LoginService } from '../../../shared-modules/login/login.service';
import { LoginSettings } from '../../../shared-modules/login/LoginSetting.model';
import { HealthService } from '../health.service';
import { Medications } from '../health.model';
import { Subscription } from 'rxjs';
import { YearService } from '../../../shared-components/year/year.service';

@Component({
    selector: 'app-medications',
    templateUrl: './medications.component.html',
    styles: [],
    animations: [detailExpand]
})
export class MedicationsComponent implements OnInit, OnChanges, OnDestroy {

    @Input() selectedStudent;
    isBusy = false;
    medications: Medications[] = [];
    medicationSelected: boolean[] = [];
    LoginSettings: LoginSettings;
    student360YearSubscription: Subscription;

    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    displayedMedicationColumns = ['More', 'Medication', 'Frequency', 'StartDate', 'EndDate', 'Dose', 'SchoolAuthorisedToAdminister'];
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private healthService: HealthService,
        private loginService: LoginService,
        private yearService: YearService
        ) {

        this.angularMatData = new TylerMatTableDataSource(this.medications);
        this.LoginSettings = this.loginService.LoginSettings;
        if (this.LoginSettings.V10 == true) {
            this.displayedMedicationColumns = ['More', 'Medication', 'StartDate', 'EndDate', 'Dose', 'SchoolAuthorisedToAdminister'];
        }

        this.student360YearSubscription = this.yearService.observableStudent360YearStream$.subscribe(() => {
            this.getMedication();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedStudent.previousValue != undefined) {
            if (changes.selectedStudent.currentValue.Id != changes.selectedStudent.previousValue.Id) {
                this.getMedication();
            }
        }
    }

    ngOnInit() {
        this.getMedication();
    }

    ngOnDestroy() {
        this.student360YearSubscription.unsubscribe();
    }

    toggleMore(index: number) {
        this.medicationSelected[index] = !this.medicationSelected[index];
    }

    toggleExpanded(row: Medications) {
        if (row.Pharmacy || row.Phone || row.RxNumber || row.Doctor || row.Comments) {
            this.angularMatData.toggleExpanded(row);
        }
    }

    checkExpanded(row: Medications): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: Medications) {
        this.angularMatData.rowKeyPress(event, row);
    }

    getMedication() {
        this.angularMatData = new TylerMatTableDataSource();
        this.isBusy = true;
        setTimeout(() => {
            this.healthService.getMedication(this.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
                this.medications = data;
                this.loadMedicationHistory();
            });
        }, 0);
    }

    loadMedicationHistory(): void {
        this.angularMatData = new TylerMatTableDataSource(this.medications);
        setTimeout(() => {
            this.angularMatData.sort = this.sort;
        }, 0);
        this.isBusy = false;
    }

    ShowRow(Pharmacy, Phone, RxNumber, Doctor, Comment, Parent, Id): boolean {
        if (Pharmacy == null) {
            Pharmacy = '';
        }
        if (Phone == null) {
            Phone = '';
        }
        if (RxNumber == null) {
            RxNumber = '';
        }
        if (Doctor == null) {
            Doctor = '';
        }
        if (Comment == null) {
            Comment = '';
        }
        if (Parent == 'Parent') {
            if (Pharmacy.length > 0 || Phone.length > 0 || RxNumber.length > 0 || Doctor.length > 0 || Comment.length > 0) {
                return true;
            }
        }
        else {
            if (Pharmacy.length > 0 || Phone.length > 0 || RxNumber.length > 0 || Doctor.length > 0) {
                return true;
            }
        }

        if (Parent == 'Parent') {
            if (document.getElementById('span' + Id) != null) {
                document.getElementById('span' + Id).style.display = 'none';
            }
        }
        return false;
    }

    // ------------Aria/Accessibility---------------------------
    getMedicationAriaRow(row: Medications): string {
        let colList: string[] = [''];
        let dataList: string[] = [''];

        if (this.LoginSettings.V10 == false) {
            colList = ['Medication', 'Frequency', 'StartDate', 'EndDate', 'Dose', 'SchoolAuthorisedToAdminister'];
            dataList = [row.Medication, row.Frequency, row.StartDate.toString(), row.EndDate.toString(), row.Dose, row.SchoolAuthorisedToAdminister];
        }
        else {
            colList = ['Medication', 'StartDate', 'EndDate', 'Dose', 'SchoolAuthorisedToAdminister'];
            dataList = [row.Medication, row.StartDate.toString(), row.EndDate.toString(), row.Dose, row.SchoolAuthorisedToAdminister];
        }

        return AriaDirective.concatAriaStrings(colList, dataList);
    }
}
